import React from 'react';

import { useForm } from 'react-hook-form';

import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';

import { getRegions } from '@luxuryescapes/lib-regions';

import { SyncPromoOfferMetricsParams } from '~/services/PromoService';

type SyncOfferMetricsFormProps = {
  onSubmit: (data: SyncPromoOfferMetricsParams) => void;
  isLoading?: boolean;
  defaultValues?: Partial<SyncPromoOfferMetricsParams>;
};

export default function SyncOfferMetricsForm({
  onSubmit,
  isLoading = false,
  defaultValues = {},
}: SyncOfferMetricsFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
  } = useForm<SyncPromoOfferMetricsParams>({
    defaultValues: {
      region: 'AU',
      ...defaultValues,
    },
    mode: 'onBlur',
  });

  const selectedRegion = watch('region');
  const regions = getRegions();

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Stack spacing={2}>
            <TextField
              {...register('startAt', {
                valueAsNumber: true,
              })}
              label="Start At"
              variant="outlined"
              type="number"
              defaultValue={0}
              fullWidth
              error={!!errors.startAt}
              helperText={errors.startAt?.message}
            />
            <TextField
              {...register('totalMaxLimit', {
                valueAsNumber: true,
              })}
              label="Limit"
              variant="outlined"
              type="number"
              defaultValue={10000}
              fullWidth
              error={!!errors.totalMaxLimit}
              helperText={errors.totalMaxLimit?.message}
            />
            <FormControl fullWidth>
              <InputLabel id="region-select-label">Region</InputLabel>
              <Select
                labelId="region-select-label"
                label="Region"
                value={selectedRegion || 'AU'}
                onChange={(e) => setValue('region', e.target.value)}
                error={!!errors.region}
              >
                {regions.map((region) => (
                  <MenuItem key={region.code} value={region.code}>
                    {region.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Button type="submit" variant="contained" color="primary" disabled={isLoading} fullWidth>
            {isLoading ? 'Syncing...' : 'Sync Offer Metrics'}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
